import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Event photo gallery links (Kwikpic, uCode P05I49)
export const PHOTO_LINKS = {
  web: "https://kwikpic-in.app.link/e/rbiq56wI45b?uCode=P05I49",
  app: "https://kwikpic-in.app.link/JZGr56wI45b?groupCode=P05I49",
};

// Returns true for phones/tablets so photo access can open the mobile app link.
export function isMobileOrTablet() {
  if (typeof navigator === "undefined" || typeof window === "undefined") return false;
  const ua = navigator.userAgent || "";
  const uaMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  // iPadOS 13+ reports as desktop Safari; detect via touch + Mac platform.
  const iPadOS = navigator.platform === "MacIntel" && (navigator.maxTouchPoints || 0) > 1;
  const narrow = window.matchMedia && window.matchMedia("(max-width: 1024px)").matches;
  return uaMobile || iPadOS || narrow;
}

// Opens the event photo gallery: mobile app link on phones/tablets, website link otherwise.
export function openPhotoGallery() {
  const url = isMobileOrTablet() ? PHOTO_LINKS.app : PHOTO_LINKS.web;
  window.open(url, "_blank", "noopener,noreferrer");
}
